import { Component, Inject  } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SocialService } from 'src/app/services/social.service';
import { SseService } from 'src/app/services/SseService';

@Component({
  selector: 'app-social-reply-dialog',

  templateUrl: './social-reply-dialog.component.html',
  styleUrl: './social-reply-dialog.component.scss'
})
export class SocialReplyDialogComponent {
  replyMessage = '';

  showAiPanel = false;
  aiPrompt = '';
  aiTone = 'profesional';
  aiGenerating = false;
  sending = false;


  constructor(public dialogRef: MatDialogRef<SocialReplyDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
    private sseService: SseService,
    private socialService: SocialService
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  send(): void {

    if (!this.replyMessage?.trim()) {
      return;
    }

    this.sending = true;

    const payload = {
      network: this.data.comment.network,
      commentId: this.data.comment.externalId,
      message: this.replyMessage
    };

    this.sseService.apiPost('social/comments/reply', true, payload, 0).then(() => {

        const network = this.data.comment.network;

        if (network === 'YOUTUBE') {

          this.refreshComments('YOUTUBE');

        } else if (network === 'TWITTER') {

          this.refreshComments('TWITTER');

        } else {

          this.closeDialog();

        }

      })
      .catch((error: any) => {
        console.error('Error enviando respuesta', error);
        this.sending = false;
      });
  }
  generateWithAi(): void {

    if (!this.aiPrompt.trim()) {
      return;
    }

    this.aiGenerating = true;

    this.socialService.generateText({prompt: this.aiPrompt, tone: this.aiTone,targetNetworks: [this.data.comment.network]}).subscribe({

      next: (res) => {

        this.replyMessage = res.generatedText;

        this.aiGenerating = false;
        this.showAiPanel = false;
        this.aiPrompt = '';
      },

      error: (err) => {

        alert(
          'Error generando texto: ' +
          (err.error?.message || err.message)
        );

        this.aiGenerating = false;
      }
    });
  }
  private refreshComments(network: string): void {
    setTimeout(() => {

      this.sseService.apiGetWithAuth(`social/comments?network=${network}`,this.sseService.licencia).subscribe({
          next: () => this.closeDialog(),
          error: (err) => {
            console.error(`Error sincronizando ${network}`, err);
            this.closeDialog();
          }
      });
    }, 3000); 
  }
  private closeDialog(): void {
    this.sending = false;
    this.dialogRef.close({ success: true });
  }
}
